export function initSidebarCollapse()  {
  const $primarySidebarParent = $('.primary-sidebar').parent()
  $(document).on('click', '.primary-sidebar .collapse-sidebar-btn', function () {
    $primarySidebarParent.toggleClass('collapsed-sidebar');
    $primarySidebarParent.toggleClass('expanded-sidebar');
  });

  $(document).on('click', '.collapsed-sidebar .primary-sidebar > div:not(.panel-heading)', function () {
    $primarySidebarParent.addClass('expanded-sidebar');
    $primarySidebarParent.removeClass('collapsed-sidebar');
  });

  const currentUrl = new URL(window.location.href)
  if (currentUrl.searchParams.get('openSidebar')) {
    $primarySidebarParent.removeClass('collapsed-sidebar');
    $primarySidebarParent.addClass('expanded-sidebar');
  }
}

$(initSidebarCollapse)